
import MinFacingSettingsService from './MinFacingSettingsService';

export { default } from './MinFacingSettingsService';
export const minFacingSettingsService = new MinFacingSettingsService();